<main>
  <ng-container *ngIf="(orderStatus$ | async) !== OrderStatus.PENDING; else loader">
    <fin-check-in-restricted-items
      [order$]="order$"
      [bound$]="bound$"
      [buttonLoading$]="loading$"
      (confirmStep)="completeCheckIn()"
    ></fin-check-in-restricted-items>
  </ng-container>
</main>

<ng-template #loader>
  <div class="align-center fill">
    <fin-loader aria-live="polite" [type]="LoaderType.EMBEDDED" [waitingFor]="'MMB.checkIn.loadingOrder'"></fin-loader>
  </div>
</ng-template>
